import ErrorBoundary from '@/components/ErrorBoundary';
import { DashboardHeader } from '@/components/dashboard/DashboardHeader';
import { StatsCards } from '@/components/dashboard/StatsCards';
import { SearchFilters } from '@/components/dashboard/SearchFilters';
import { LeadsTable } from '@/components/dashboard/LeadsTable';
import { useEarlyAccessLeads } from '@/hooks/useEarlyAccessLeads';
import { useLeadsFilters } from '@/hooks/useLeadsFilters';
import { exportToCSV } from '@/utils/csvExporter';

const EarlyAccessLeads = () => {
  const {
    leads,
    stats,
    loading,
    refreshing,
    deleting,
    deletingAll,
    fetchLeads,
    deleteLead,
    deleteAllLeads
  } = useEarlyAccessLeads();

  const {
    filteredLeads,
    searchTerm,
    setSearchTerm,
    interviewFilter,
    setInterviewFilter,
    dateFilter,
    setDateFilter,
    timeFilter,
    setTimeFilter,
    dateRange,
    setDateRange,
    hasActiveFilters,
    clearFilters
  } = useLeadsFilters(leads);

  const handleRefresh = () => {
    fetchLeads(true);
  };

  const handleExportCSV = () => {
    exportToCSV(filteredLeads);
  };

  const handleDeleteAll = () => {
    deleteAllLeads();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary/20 via-secondary/10 to-accent/20 p-8">
        <div className="flex items-center justify-center h-64">
          <div className="text-lg text-muted-foreground">Cargando datos...</div>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gradient-to-br from-primary/20 via-secondary/10 to-accent/20 p-8">
        <div className="max-w-7xl mx-auto space-y-8">
          <DashboardHeader
            onRefresh={handleRefresh}
            onExportCSV={handleExportCSV}
            onDeleteAll={handleDeleteAll}
            refreshing={refreshing}
            deletingAll={deletingAll}
            totalLeads={leads.length}
          />
          
          <StatsCards stats={stats} />
          
          <SearchFilters
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            interviewFilter={interviewFilter}
            setInterviewFilter={setInterviewFilter}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            timeFilter={timeFilter}
            setTimeFilter={setTimeFilter}
            dateRange={dateRange}
            setDateRange={setDateRange}
            hasActiveFilters={hasActiveFilters}
            clearFilters={clearFilters}
            filteredCount={filteredLeads.length}
            totalCount={leads.length}
          />
          
          <LeadsTable
            leads={filteredLeads}
            totalLeads={leads.length}
            onDeleteLead={deleteLead}
            deleting={deleting}
            clearFilters={clearFilters}
          />
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default EarlyAccessLeads;